import { useEffect, useRef, useState } from 'react';

function defaultCompareFunction(item, selectedPond) {
  return item.pond.description.includes(selectedPond.description);
}

export function usePondCycle({
  pondCycles, location, formik, fieldValue = 'cycle', compareFunction = defaultCompareFunction,
}) {
  const [selectedPondCycle, setSelectedPondCycle] = useState(null);
  const previousPondRef = useRef(null);

  useEffect(() => {
    if (
      pondCycles.length > 0
      && location.state.pond
      && location.state.pond !== previousPondRef.current
    ) {
      previousPondRef.current = location.state.pond;
      const findPondCycles = pondCycles.find((item) => compareFunction(item, location.state.pond));
      setSelectedPondCycle(findPondCycles);
      formik.setFieldValue(fieldValue, findPondCycles?.id);
    }
  }, [fieldValue, formik, location.state.pond, pondCycles, compareFunction]);

  return {
    selectedPondCycle,
    setSelectedPondCycle,
    hasError: !selectedPondCycle && formik.touched[fieldValue] && formik.errors[fieldValue],
  };
}
